import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import { useTranslation } from 'react-i18next'

import Button from '../../../components/Button'

import { onAuthLinkClickHandler } from '../../../pages/SocialAuthorize/AuthorizePlatformDetails/SocialAuthorizeButtons/helpers'

import { getFacebookDebugTokens } from '../../../modules/actions/socialAccounts'
import {
  getFacebookDebugTokensSelector,
  getFacebookDebugTokensWasLoadedSelector
} from '../../../modules/selectors/socialAccounts'

import useStyles from '../../../pages/SocialAuthorize/AuthorizePlatformDetails/SocialAuthorizeButtons/style'

const FacebookBusinessManagementScopeChecker = ({ children }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()

  const getFacebookDebugTokensWasLoaded = useSelector(getFacebookDebugTokensWasLoadedSelector)
  const facebookDebugTokens = useSelector(getFacebookDebugTokensSelector)

  const hasBusinessManagementScope = facebookDebugTokens.find(
    item => item.permission === 'business_management' && item.status === 'granted'
  )

  useEffect(() => {
    dispatch(getFacebookDebugTokens())
  }, [dispatch])

  if (!getFacebookDebugTokensWasLoaded) {
    return (
      <Skeleton
        style={{
          marginTop: '24px',
          width: '330px',
          height: '40px'
        }}
      />
    )
  }

  return hasBusinessManagementScope ? (
    children
  ) : (
    <a
      href="/api/allauth/facebook/login/?auth_type=rerequest&scope=business_management"
      rel="noreferrer nofollow"
      onClick={onAuthLinkClickHandler}
    >
      <Button solid className={classes.facebookBtn} type="button">
        {t('Continue with Facebook')}
      </Button>
    </a>
  )
}

export default FacebookBusinessManagementScopeChecker
